import { Component, Input, OnInit } from '@angular/core';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { PageCategoryType, PageCO } from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-image-showcase',
  templateUrl: './image-showcase.component.html',
  styleUrls: ['./image-showcase.component.scss']
})
export class ImageShowcaseComponent implements OnInit {

  @Input() category!: PageCategoryType;

  images: any[] = [];

  constructor(private pageDataService: PageDataService) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();

    this.pageDataService.pageData$
      .subscribe(data => {
        if (data?.length) {
          this.extractImages(data[0]);
        }
      });
  }

  private extractImages(page: PageCO): void {
    const categoryData = page.category?.find(
      c => c.category === PageCategoryType.FEATURED_IMAGES
    );

    this.images =
      categoryData?.image?.map(img => ({
        fileUrl: this.getFileUrl(img.file.fileUUID),
        title: img.file?.title || '',
        desc: img.descp || ''
      })) ?? [];
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }
}
